const { pix } = require('@transfeeradev/api-enums');

const FROM_BCB = {
  [pix.bcb.keyType.CPF]: pix.keyType.CPF,
  [pix.bcb.keyType.CNPJ]: pix.keyType.CNPJ,
  [pix.bcb.keyType.PHONE]: pix.keyType.TELEFONE,
  [pix.bcb.keyType.EMAIL]: pix.keyType.EMAIL,
  [pix.bcb.keyType.EVP]: pix.keyType.CHAVE_ALEATORIA
};
const TO_BCB = {
  [pix.keyType.CPF]: pix.bcb.keyType.CPF,
  [pix.keyType.CNPJ]: pix.bcb.keyType.CNPJ,
  [pix.keyType.TELEFONE]: pix.bcb.keyType.PHONE,
  [pix.keyType.EMAIL]: pix.bcb.keyType.EMAIL,
  [pix.keyType.CHAVE_ALEATORIA]: pix.bcb.keyType.EVP
};

class ConvertPixKeyTypeService {
  static fromBcb(keyType) {
    if (!keyType) {
      return keyType;
    }
    return FROM_BCB[keyType];
  }

  static toBcb(keyType) {
    if (!keyType) {
      return keyType;
    }
    return TO_BCB[keyType];
  }

  static fromTopazio(keyType) {
    return ConvertPixKeyTypeService.fromBcb(keyType);
  }

  static toTopazio(keyType) {
    return ConvertPixKeyTypeService.toBcb(keyType);
  }
}

module.exports = ConvertPixKeyTypeService;
